<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Report PDF - Setting
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ data.index + 1 }}
        </template>
        <template v-slot:cell(iklan)="data">
          <span v-if="data.item.iklan == 1"><i class="fa fa-check"></i></span>
        </template>
        <template v-slot:cell(koran)="data">
          <span v-if="data.item.koran == 1"><i class="fa fa-check"></i></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
            <!-- <a href="javascript:void(0)" @click.stop="edit(data.item)" class="text-warning">
              <i class="fa fa-eye"></i>
            </a>
                        <span class="mx-1"></span> -->

            <a href="javascript:void(0)" @click.stop="edit(data.item)" title="Clik for edit">
              <i class="fa fa-pencil"></i>
            </a>
            <span class="mx-1"></span>
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)" title="Clik for delete"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="6">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-card v-show="!showList">
      <div slot="header">
        REPORT PDF - SETTING FORM
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="closeFrm()">
            <i class="fa fa-close"></i> Cancel</b-button
          >
        </div>
      </div>
      <b-input-group>
        <b-input-group-prepend
          ><label>Name Key</label></b-input-group-prepend
        >
        <b-form-input v-model="frmdata.namekey"></b-form-input>
         <b-input-group-append
          ><label class="p-1">Report Name</label></b-input-group-append
        >
        <b-form-input v-model="frmdata.name"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Template</label></b-input-group-prepend>
        <b-textarea
          v-model="frmdata.template"
          rows="100"
          max-rows="100"
        ></b-textarea>
      </b-input-group>
    </b-card>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
const moment = require('moment');

toastr.init();

export default {
  components: {},

  data() {
    return {
      showList: true,
      frmdata: {
        name: "",
        template: "",
      },
      options: {},
      tblData: {
        tablename: "reportpdftpl",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "name",
        sortDesc: true,
      },
      model:{}
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          label: "No.",
          thStyle: "width:50px",
          sortable: true,
        },
        {
          key: "namekey",
          label: "Name Key",
          sortable: true,
        },
        {
          key: "name",
          label: "Name Template",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center",
        },
      ];
      return fields;
    },
  },
  // watch:{
  //
  //   },
  created: async function () {},
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str = "";
      //   if (this.filter.crewnik) {
      //     str = "crewnik=%" + encodeURIComponent(this.filter.crewnik) + "%";
      //   }
      //   if (this.filter.salesae_name) {
      //     str += str ? "&" : "";
      //     str =
      //       str +
      //       "salesae_name=" +
      //       encodeURIComponent(this.filter.salesae_name) +
      //       "%";
      //   }
      //   this.tblData.customQuery = str;

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.tablekey;
      this.showForm = true;
      this.showList = false;
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.update({
              tablename: "reportpdftpl",
              key: this.model.tablekey,
              data: {
                template: this.frmdata.template,
                name: this.frmdata.name,
                modifiedby:this.$store.state.user.username,
                modified:moment().format('YYYY-MM-DD HH:mm:ss'),
                isdeleted:1
              },
            });
      this.refresh();
    },
    closeFrm() {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = false;
      this.showList = true;
    },

    save: async function (callback) {
      this.frmdata.iklan = this.frmdata.iklan || "0";
      this.frmdata.koran = this.frmdata.koran || "0";

      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "reportpdftpl",
              key: this.frmdata.idlama,
              data: {
                template: this.frmdata.template,
                name: this.frmdata.name,
                modifiedby:this.$store.state.user.username,
                modified:moment().format('YYYY-MM-DD HH:mm:ss')
              },
            });
          } else {
            await crud.insert({
              tablename: "reportpdftpl",
              data: {
                template: this.frmdata.template,
                namekey: this.frmdata.namekey,
                name: this.frmdata.name,
                createby:this.$store.state.user.username
              },
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
  },
};
</script>
